/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tame_Sandy_Swan_NodInputs */

const en_tame_sandy_swan_nod = /** @type {(inputs: Tame_Sandy_Swan_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specify for which reports the access rights should be configured.`)
};

const de_tame_sandy_swan_nod = /** @type {(inputs: Tame_Sandy_Swan_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle aus, für welche Berichte die Berechtigungen gesetzt werden sollen.`)
};

/**
* | output |
* | --- |
* | "Specify for which reports the access rights should be configured." |
*
* @param {Tame_Sandy_Swan_NodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tame_sandy_swan_nod = /** @type {((inputs?: Tame_Sandy_Swan_NodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tame_Sandy_Swan_NodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tame_sandy_swan_nod(inputs)
	return de_tame_sandy_swan_nod(inputs)
});